import { Component, Input } from '@angular/core';
import { Summary } from '../types';

@Component({
  selector: 'dashboard-customers-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class DashboardCustomersSummaryComponent {
  @Input() data: Summary;
}
